/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PolyfillsInputs */

const en_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polyfills`)
};

const ar_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعويضات`)
};

const bn_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পলিফিল`)
};

const de_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polyfills`)
};

const es_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polirellenos`)
};

const fr_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polyremplissages`)
};

const pt_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polipreenchimentos`)
};

const zh_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polyfills`)
};

const tr_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çoklu Doldurmalar`)
};

const ru_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полифиллы`)
};

const pl_svchip_polyfills = /** @type {(inputs: Svchip_PolyfillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polifilly`)
};

/**
* | output |
* | --- |
* | "Polyfills" |
*
* @param {Svchip_PolyfillsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_polyfills = /** @type {((inputs?: Svchip_PolyfillsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PolyfillsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_polyfills(inputs)
	if (locale === "bn") return bn_svchip_polyfills(inputs)
	if (locale === "de") return de_svchip_polyfills(inputs)
	if (locale === "es") return es_svchip_polyfills(inputs)
	if (locale === "fr") return fr_svchip_polyfills(inputs)
	if (locale === "pt") return pt_svchip_polyfills(inputs)
	if (locale === "zh") return zh_svchip_polyfills(inputs)
	if (locale === "tr") return tr_svchip_polyfills(inputs)
	if (locale === "ru") return ru_svchip_polyfills(inputs)
	if (locale === "pl") return pl_svchip_polyfills(inputs)
	return en_svchip_polyfills(inputs)
});